// extracted by mini-css-extract-plugin
module.exports = {"listItem":"SummaryList_listItem__0fEB3","listItemUrl":"SummaryList_listItemUrl__Ihjqt","link":"SummaryList_link__AEPNE","small":"SummaryList_small__YCTVl"};